import type { CoordinatePair } from "./types";

export const ROUTE_API_PATH = "/api/routes/resolve";
export const ROUTE_API_MAX_LEGS = 12;
export const ROUTE_CACHE_TTL_SECONDS = 24 * 60 * 60;
export const ORS_PROVIDER_ID = "heigit-openrouteservice";

export type RoadRouteMode = "walk" | "bike" | "drive";
export type RouteApiErrorCode =
  | "INVALID_INPUT"
  | "UNSUPPORTED_MODE"
  | "NO_ROUTE"
  | "UPSTREAM_RATE_LIMITED"
  | "UPSTREAM_TIMEOUT"
  | "UPSTREAM_UNAVAILABLE";

export interface RouteApiLegRequest {
  id: string;
  fingerprint: string;
  mode: RoadRouteMode;
  from: CoordinatePair;
  to: CoordinatePair;
}

export interface RouteApiRequest {
  legs: RouteApiLegRequest[];
  locale?: string;
  force?: boolean;
}

export interface RouteApiLegData {
  id: string;
  fingerprint: string;
  distanceKm: number;
  durationMinutes: number;
  geometry: CoordinatePair[];
  providerId: typeof ORS_PROVIDER_ID;
  fetchedAt: string;
  expiresAt: string;
  cached: boolean;
}

export interface RouteApiLegSuccess {
  ok: true;
  data: RouteApiLegData;
}

export interface RouteApiLegFailure {
  ok: false;
  id: string;
  fingerprint: string;
  error: {
    code: RouteApiErrorCode;
    message: string;
    retryable: boolean;
  };
}

export type RouteApiLegResult = RouteApiLegSuccess | RouteApiLegFailure;

export type RouteApiResponse =
  | { ok: true; data: { legs: RouteApiLegResult[] } }
  | { ok: false; error: { code: "INVALID_INPUT"; message: string; retryable: false } };

export function isRoadRouteMode(value: unknown): value is RoadRouteMode {
  return value === "walk" || value === "bike" || value === "drive";
}

export function routeProfile(mode: RoadRouteMode): "foot-walking" | "cycling-regular" | "driving-car" {
  return mode === "walk" ? "foot-walking" : mode === "bike" ? "cycling-regular" : "driving-car";
}
